// extracted by mini-css-extract-plugin
module.exports = {"KeyboarInstalment":"KeyboarInstalment_KeyboarInstalment__ySWEl","botao":"KeyboarInstalment_botao__2s81b","botaoCancelar":"KeyboarInstalment_botaoCancelar__1oEgW"};